module.exports = __webpack_public_path__ + "static/media/engage-design1.81a4d043.jpg";